import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PayResultsPage from './PayResultsPage';

export const prefix = 'bm-p-pay-results';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PayResultsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
